/**
 * ActivityIcon (0017) — render a category's Lucide icon in the web UI, and build
 * a matching SVG data-URL for map markers so Google + Leaflet markers look the
 * same as the rest of the app.
 */
import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { visualForCategoryName, DEFAULT_VISUAL } from '../../utils/activityVisuals';

// Web icon for a category.
export default function ActivityIcon({ categoryName, color, size = 18, strokeWidth = 2, ...rest }) {
  const v = visualForCategoryName(categoryName);
  const Icon = v.Icon || DEFAULT_VISUAL.Icon;
  return <Icon size={size} color={color || v.color} strokeWidth={strokeWidth} {...rest} />;
}

// Map marker: a category-colored circle with the white Lucide glyph, as an SVG
// data URL. Cached by category name (~12 values) so we don't re-serialize on
// every render. Pass '' / null for the default location pin.
const _markerCache = new Map();
export function markerIconDataUrl(categoryName) {
  const key = categoryName || '__default__';
  if (_markerCache.has(key)) return _markerCache.get(key);
  const v = visualForCategoryName(categoryName) || DEFAULT_VISUAL;
  const Icon = v.Icon || DEFAULT_VISUAL.Icon;
  const glyph = renderToStaticMarkup(
    React.createElement(Icon, { color: '#ffffff', size: 16, strokeWidth: 2.5 })
  );
  const svg =
    '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">' +
    `<circle cx="15" cy="15" r="13" fill="${v.color}" stroke="#ffffff" stroke-width="2"/>` +
    `<g transform="translate(7,7)">${glyph}</g>` +
    '</svg>';
  const url = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
  _markerCache.set(key, url);
  return url;
}
